import React, {Component} from 'react';

import Input from 'Components/Input'
import Dropdown from 'Components/Dropdown';
import { ReactComponent as PlusIcon } from 'Icons/plus.svg';
import { ReactComponent as TrashIcon } from 'Icons/trash.svg';
import { ReactComponent as CloseIcon } from 'Icons/close-circle.svg';

import PlacesAutoComplete from 'Components/PlacesAutoComplete';


class LCLStopDetails extends Component {
    constructor(props) {
        super(props);
        this.trip = props.trip;
        this.viewMode = props.viewMode;
        this.lclStops = this.trip.lclStops;
        this.state = {
            lclStops: props.trip.lclStops,
        }
    }
    addLCLStop = ()=> {
        if(this.viewMode) {
            return;
        }
        this.props.trip.addLCLStop();
        this.setState({
            lclStops: this.props.trip.lclStops
        });
    }
    addSlab = (index)=> {
        if(this.viewMode) {
            return;
        }
        this.lclStops[index].addSlab();
        this.setState({
            lclStops: this.lclStops
        })
    }
    setFromLocation = (index, location)=> {
        if(this.viewMode) {
            return;
        }
        this.lclStops[index].setFromLocation(location);
        this.props.onChange();
    }
    setToLocation = (index, location)=> {
        if(this.viewMode) {
            return;
        }
        this.lclStops[index].setToLocation(location);
        this.props.onChange();
    }
    onChange = (index, e)=> {
        if(this.viewMode) {
            return;
        }
        const name = e.target.name;
        const value = e.target.value;
        const lclStops = [...this.state.lclStops];
        lclStops[index][name] = value;
        this.setState({
            lclStops
        })
        this.lclStops[index]['set' + name.substr(0,1).toUpperCase() + name.slice(1) ](value);
    }
    selectSlab = (stopIndex, slabIndex, value)=> {
        if(this.viewMode) {
            return;
        }
        this.lclStops[stopIndex].slabs[slabIndex].setSlabType(value);
        this.setState({
            lclStops: this.lclStops
        })
    }
    selectUnit = (stopIndex, slabIndex, value)=> {
        if(this.viewMode) {
            return;
        }
        this.lclStops[stopIndex].slabs[slabIndex].setUnit(value);
        this.setState({
            lclStops: this.lclStops
        })
    }
    changeExpectingPrice = (stopIndex, slabIndex, e)=> {
        if(this.viewMode) {
            return;
        }
        this.lclStops[stopIndex].slabs[slabIndex].setExpectingPrice(e.target.value);
        this.setState({
            lclStops: this.lclStops
        });
    }
    removeSlab = (stopIndex, slabIndex)=> {
        if(this.viewMode) {
            return;
        }
        this.lclStops[stopIndex].removeSlab(slabIndex);
        this.setState({
            lclStops: this.lclStops
        });
    }
    removeLCLStop = (index)=>{
        if(this.viewMode) {
            return;
        }
        this.trip.removeLCLStop(index);
        this.setState({
            lclStops: this.trip.lclStops
        });
    }
    render() {
        const { lclStops } = this.state;
        const {
            businessVolumes,
            slabs
        } = this.props
        return (
            <div className="">
                {
                    lclStops.map((lclStop, index)=> {
                        return (
                            <div key={lclStop.id} className="pr border-status-bar br-5 pl-10 pr-10 pt-20 pb-20 mb-30">
                                {lclStops.length > 1 && <CloseIcon className="pa t--15 r--15 curP" onClick={this.removeLCLStop.bind(this, index)}/>}
                                <div className="header-medium-color fBold fs-20 mb-20">Stop {index + 1}</div>
                                <div className="flex flex-between mb-30">
                                    <div className="col-2 mr-20">
                                        <div className="fSemibold fs-18 header-medium-color mb-5">From</div>
                                        {!this.viewMode && <PlacesAutoComplete setLocation={this.setFromLocation.bind(this, index)} value={lclStop.from.location || ''}/>}
                                        {this.viewMode && <Input value={lclStop.from.location || ''}/>}
                                    </div>
                                    <div className="col-2">
                                        <div className="fSemibold fs-18 header-medium-color mb-5">To</div>
                                        {!this.viewMode && <PlacesAutoComplete setLocation={this.setToLocation.bind(this, index)} value={lclStop.to.location || ''}/>}
                                        {this.viewMode && <Input value={lclStop.to.location || ''}/>}
                                    </div>
                                </div>
                                <div className="flex flex-between mb-30">
                                    <div className="col-2 mr-20">
                                        <div className="fSemibold fs-18 header-medium-color mb-5">Address / Instructions</div>
                                        <Input placeholder="Enter landmark or instruction" name="fromLandmark" value={lclStop.fromLandmark || ''} onChange={this.onChange.bind(this, index)}/>
                                    </div>
                                    <div className="col-2">
                                        <div className="fSemibold fs-18 header-medium-color mb-5">Address / Instructions</div>
                                        <Input placeholder="Enter landmark or instruction" name="toLandmark" value={lclStop.toLandmark} onChange={this.onChange.bind(this, index)}/>
                                    </div>
                                </div>
                                {lclStop.slabs && lclStop.slabs.length > 0 && <div className="flex mb-5 flex-middle">
                                    <div className="wt-150 fs-12 caption-color">Slab</div>
                                    <div className="wt-150 fs-12 caption-color ml--2">Measuring Unit</div>
                                    <div className="ml--2 fs-12 caption-color ml--5">Expecting Price</div>
                                </div>}
                                {
                                    lclStop.slabs.map((slab, slabIndex)=> {
                                        return (
            											<div className="flex flex-between mb-10 flex-middle" key={slabIndex}>
                                                <Dropdown 
                                                    items={slabs} 
                                                    displayKey="name" 
                                                    label="Select Slab"
                                                    name="slabType" selectedItem={slabs.find((slabConstant)=> {
                                                        return slab.slabType === slabConstant.value
                                                    })} 
                                                    className="wt-150 mr-10" 
                                                    onSelect={this.selectSlab.bind(this, index, slabIndex)}
                                                />
                                                <Dropdown 
                                                    items={businessVolumes} 
                                                    displayKey="name" 
                                                    label="Select Unit"
                                                    name="businessUnit" selectedItem={businessVolumes.find((businessVolumeConstant)=> {
                                                        return slab.unit === businessVolumeConstant.value
                                                    })} 
                                                    className="wt-150 mr-10" 
                                                    onSelect={this.selectUnit.bind(this, index, slabIndex)}
                                                />
                                                <div className="wt-150"><Input className="wt-150 mr-10" placeholder="Enter Price" name="" value={slab.expectingPrice || ''} onChange={this.changeExpectingPrice.bind(this, index, slabIndex)}/></div>
                                                <div className="curP flex flex-middle ml-30" onClick={this.removeSlab.bind(this, index, slabIndex)}><TrashIcon className="mr-10"/><span className="fSemibold theme-color fs-14">Remove</span></div>
                                             </div>
                                        )
                                    })
                                }
                                
                                 <div className="flex flex-middle curP mt-30 wt-max-content" onClick={this.addSlab.bind(this, index)}>
                                    <div className="flex flex-middle flex-center bg-theme wt-25 ht-25 br-20 border-none br-50p mr-5">
                                       <PlusIcon className="wt-15 ht-15"/>
                                    </div>
                                    <div className="fSemibold fs-16 fBold header-dark-color">Add Slab</div>
                                 </div>
                            </div>
                        )   
                    })
                }
                <div className="flex flex-middle curP mt-30 wt-max-content" onClick={this.addLCLStop}>
                    <div className="flex flex-middle flex-center bg-theme wt-25 ht-25 br-20 border-none br-50p mr-5">
                        <PlusIcon className="wt-15 ht-15"/>
                    </div>
                    <div className="fSemibold fs-16 fBold header-dark-color">Add Stop</div>
                </div>
            </div>
        )
    }
}

export default LCLStopDetails;
